import { ID } from '@griply/types';

// A list only renders part of a stored order; ids it never showed keep their slots.
export const mergeReorderedSubset = (existing: ID[], reordered: ID[]): ID[] => {
  const subset = new Set(reordered);
  const firstIndex = existing.findIndex((id) => subset.has(id));
  const remaining = existing.filter((id) => !subset.has(id));
  const insertionIndex =
    firstIndex === -1
      ? remaining.length
      : existing.slice(0, firstIndex).filter((id) => !subset.has(id)).length;

  return [
    ...remaining.slice(0, insertionIndex),
    ...reordered,
    ...remaining.slice(insertionIndex),
  ];
};
